import AutorenewIcon from '@mui/icons-material/Autorenew';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useDownloadInstructions from '../../hooks/useDownloadInstructions';
import { DownloadButtonProps } from '../../types';
import DownloadButtonStyles from './DownloadButton.style';

const DownloadButton = ({
  enterpriseId,
  currency,
  walletId,
}: DownloadButtonProps) => {
  const { t } = useTranslation();
  const { loading, handleDownload } = useDownloadInstructions({
    enterpriseId,
    currency,
    walletId,
  });
  return (
    <div className={DownloadButtonStyles.buttonWrapper}>
      <Button
        className={DownloadButtonStyles.button}
        variant="outlined"
        onClick={() => handleDownload()}
        disabled={loading}
        endIcon={
          !loading ? (
            <FileDownloadOutlinedIcon />
          ) : (
            <AutorenewIcon className="animate-spin" />
          )
        }
      >
        {t('aiDownloadButton')}
      </Button>
    </div>
  );
};

export default DownloadButton;
